'use client'

import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'
import type { LightboxItem } from '@/lib/lightbox-image'

if (typeof Fancybox.Plugins?.Hash?.setup === 'function') {
  Fancybox.Plugins.Hash.setup = () => {}
  Fancybox.Plugins.Hash.startFromUrl = () => {}
}

function escapeHtml(value: string) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function slideCaption(item: LightboxItem) {
  const title = item.title?.trim() || ''
  const text = item.description?.trim() || ''
  if (title && text) return `<strong>${escapeHtml(title)}</strong><br>${escapeHtml(text)}`
  return title || text || undefined
}

const TOOLBAR = {
  left: [] as string[],
  middle: [] as string[],
  right: ['close'],
}

export function openFancybox(
  items: LightboxItem[],
  index = 0,
  triggerEl?: Element | null,
) {
  if (typeof window === 'undefined' || items.length === 0) return

  const startIndex = Math.max(0, Math.min(index, items.length - 1))
  const trigger = triggerEl instanceof HTMLElement ? triggerEl : undefined
  const nestedThumb = trigger?.querySelector('img')
  const thumbEl = trigger instanceof HTMLImageElement
    ? trigger
    : nestedThumb instanceof HTMLImageElement
      ? nestedThumb
      : undefined

  Fancybox.close(true)
  Fancybox.show(
    items.map((item, itemIndex) => ({
      src: item.src,
      type: 'image',
      alt: item.alt || item.title || '',
      caption: slideCaption(item) || undefined,
      thumbSrc: item.thumb || item.src,
      thumbEl: itemIndex === startIndex ? thumbEl || undefined : undefined,
    })),
    {
      startIndex,
      closeExisting: true,
      backdropClick: 'close',
      dragToClose: true,
      hideScrollbar: false,
      placeFocusBack: false,
      zoomEffect: false,
      triggerEl: trigger,
      theme: 'dark',
      mainClass: 'haber-fancybox',
      closeButton: false,
      idle: 4000,
      on: {
        destroy() {
          const html = document.documentElement
          const body = document.body
          html.style.removeProperty('padding-right')
          body.style.removeProperty('padding-right')
          html.style.removeProperty('overflow')
          body.style.removeProperty('overflow')
          html.style.removeProperty('margin-right')
          body.style.removeProperty('margin-right')
        },
      },
      plugins: {
        Hash: () => ({ init() {}, destroy() {} }),
      },
      Carousel: {
        infinite: false,
        transition: 'slide',
        Toolbar: {
          absolute: true,
          display: TOOLBAR,
        },
        Thumbs: {
          type: 'classic',
          minCount: 2,
          showOnStart: true,
        },
      },
      l10n: {
        CLOSE: 'Kapat',
        NEXT: 'Sonraki',
        PREV: 'Önceki',
        MODAL: 'Görsel önizleme',
        ERROR: 'Görsel yüklenemedi',
        IMAGE_ERROR: 'Görsel yüklenemedi',
        ZOOM_IN: 'Yakınlaştır',
        ZOOM_OUT: 'Uzaklaştır',
        TOGGLE_1TO1: '1:1',
        TOGGLE_FULL: 'Büyüt',
        TOGGLE_THUMBS: 'Küçük resimler',
        TOGGLE_FULLSCREEN: 'Tam ekran',
        ELEMENT_NOT_FOUND: 'Görsel bulunamadı',
      },
    },
  )
}
